import { render, staticRenderFns } from "./multipleImageShadow.vue?vue&type=template&id=5605d689&"
import script from "./multipleImageShadow.vue?vue&type=script&lang=ts&"
export * from "./multipleImageShadow.vue?vue&type=script&lang=ts&"
import style0 from "./multipleImageShadow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports